module.exports = __webpack_public_path__ + "assets/f087d96c95147508ec6954085a25275a.mp3";